import { Badge, Box, Card, Group, Text, useMantineTheme } from "@mantine/core";
import { CaptureEventType } from "core/components/capture/CaptureThumb";
import ImagePreview from "core/components/imagePreview/ImagePreview";

import Moment from "react-moment";
import classes from './StyleAssetThumb.module.scss';

export const StyleAssetThumb = ({
  shot,
  src,
  size = 200,
  tags = "",
  showMetaInfo = true,
  showAssetMenu = true,
  listMetaDisplay = false,
  onAssetMenuClick,
  onImageEvent,
  fit = "cover",
}) => {
  const theme = useMantineTheme();
  //   const shotLabel = shot?.capture?.stylePart
  //     ? `${shot.capture?.stylePart}-${shot.capture?.assignedSequence}.jpg`
  //     : "";
  const shotLabel = "";
  return (
    <Card pb={0}
      withBorder
      radius={"md"}
      onClick={() => {
        if (onImageEvent) onImageEvent(CaptureEventType.IMAGE_CLICK, shot);
      }}
    >
      <Card.Section>
        {/* <Image src={src} alt={''} height={size} /> */}
        {/* <ResolverImage
          className={classes.image}
          fit={fit}
          src={src}
          alt={src}
          height={size}
          radius={theme.radius.md}
        /> */}

        <ImagePreview
          file={{ url: shot?.preview }}
          onClick={() => {}}
          height={size}
          width={"auto"}
          fit={fit}
        />
      </Card.Section>

      
        <div className={showMetaInfo?`${classes.metaInfo} ${classes.open}`:`${classes.metaInfo}`}
          style={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            //   marginLeft: listView === "LIST" && showMetaInfo ? 20 : 0,
          }}
        >
          <Group position="apart" wrap="nowrap" sx={{ marginTop: -2 }}>
            {/* {shotLabel ? (
            <Text weight={500} size="sm" truncate>
              {shotLabel}
            </Text>
          ) : (
            <Text weight={500} size="sm" truncate color="dimmed">
              No Asset Assigned
            </Text>
          )} */}

            <Group wrap="nowrap">
              {/* <div style={{ minHeight: 30 }}>
              {shot.capture && (
                <Badge color="green" variant="light">
                  {shot.capture.status}
                </Badge>
              )}
            </div> */}

              {/* {showAssetMenu && shot && (
              <Menu shadow="md" width={200}>
                <Menu.Target>
                  <ActionIcon>
                    <IconDots />
                  </ActionIcon>
                </Menu.Target>

                <Menu.Dropdown>
                  <Menu.Item
                    onClick={() =>
                      onAssetMenuClick?.({
                        asset: shot,
                        type: "ARCHIVE",
                      })
                    }
                    icon={<IconArchive size={14} />}
                  >
                    Archive Asset
                  </Menu.Item>
                </Menu.Dropdown>
              </Menu>
            )} */}
            </Group>
          </Group>

          <>
            {/* <Divider mt="xs" /> */}
            {/* <Card.Section py="md" mx={0}>
              <Text className={classes.title} size="sm" weight={700}>
                {shot.label}
              </Text>
              <Text
                className={classes.title}
                size="sm"
                sx={{ flexGrow: 1 }}
                c={shot.notes ? undefined : "dimmed"}
              >
                {shot.notes || "No Notes"}
              </Text>
            </Card.Section>
            <Divider /> */}
            <Card.Section
              py="md"
              mx={0}
              mb={'sm'}
              style={{
                display: "flex",
                flexDirection: listMetaDisplay ? "row" : "column",
                gap: listMetaDisplay ? 30 : 15,
              }}
            >
              <MetaInfoBox
                label="Style Number"
                value={shot.styleNumber}
                showMargin={!listMetaDisplay}
              />
              <MetaInfoBox label="Department" value={shot.dept} />
              <MetaInfoBox
                label="Distributed"
                value={
                  <Moment
                    date={shot.distributionDate}
                    parse="YYYY-MM-DD-hh-mm-ss"
                    format="DD/MM/YYYY"
                    trim
                  />
                }
              />

              <MetaInfoBox
                label="Tags"
                value={
                  shot && shot.tags && shot.tags.length > 0 ? (
                    <Group gap={"xs"} mt={"xs"}>
                      {shot &&
                        shot.tags &&
                        shot.tags.length &&
                        shot.tags.split(",").map((val, idx) => (
                          <Badge
                            key={idx}
                            variant="default"
                            //   gradient={{ from: "#ed6ea0", to: "#ec8c69", deg: 35 }}
                          >
                            {val}
                          </Badge>
                        ))}
                    </Group>
                  ) : (
                    <Text c={'dimmed'}>No Tags available</Text>
                  )
                }
              />

              {/* <MetaInfoBox label="Session" value={shot.capture?.sessionCode} /> */}
            </Card.Section>
          </>
        </div>
      
    </Card>
  );
};

// Helper component for metadata boxes
const MetaInfoBox = ({ label, value, showMargin }) => {
  const theme = useMantineTheme();
  return (
    <Box mt={showMargin ? "mt" : 0}>
      <Text size="xs" c="dimmed">
        {label}
      </Text>
      <Group>
        <Box style={{ fontSize: theme.fontSizes.sm }}>{value || "-"}</Box>
      </Group>
    </Box>
  );
};
